module.exports = {
      id: "wm-usage",
      viewBox: "0 0 109 105",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#wm",
      toString: function () {
        return this.url;
      }
    }